import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppLoaderService } from '../service/app-loader/app-loader.service';
import { StyleDirectionService } from '../service/style-direction/style-direction.service';
import { CartService } from '../../appshared/invoice/cart.service';
import { LocalStoreService } from '../service/local-store.service';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { CategoryModule } from '../../appshared/masters/category/category.module';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

    cartProducts;
    ComID: number = 2;


    CurrentLangSrc: string = "assets/img/flag/us-flag.jpg";
    CurrentLangName: string = "Eng";
    CurrentLangCode: string = "en";

    SecondLangSrc: string = "assets/img/flag/arab-flag.jpg";
    SecondLangName: string = "عربي";
    SecondLangCode: string = "ar";
    currentLang: string = "en";


    CurrentCurrencyName: string = "OMR";
    CurrentCurrencyCode: string = "1";

    SecondCurrencyName: string = "$";
    SecondCurrencyCode: string = "2";
    currentCurrency: string = "1";
    public SelectedLanguage: string = "en";


    // cartProducts = this.cartService.getTotal();

    //mainForm: CurrencyModule = new CurrencyModule();

    constructor(private serv: CategoryService, private localS: LocalStoreService, public translate: TranslateService, private styleDir: StyleDirectionService, private loader: AppLoaderService, private cartService: CartService) { }

    ngOnInit(): void {
        this.fillCategory();

        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }

        this.cartService.ordersChanged.subscribe(items =>
            this.cartProducts = items
        )

        var cart = this.localS.getItem('CartItems');

        if (cart != null) {
            this.cartService.setItemsData(cart);
        }


        if (this.localS.getItem('Lang') == 'ar') {
            this.currentLang = "ar";
        }

        if (this.currentLang !== 'ar') {

            this.CurrentLangSrc = "assets/img/flag/us-flag.jpg";
            this.CurrentLangName = "Eng";
            this.CurrentLangCode = "en";

            this.SecondLangSrc = "assets/img/flag/arab-flag.jpg";
            this.SecondLangName = "عربي";
            this.SecondLangCode = "ar";
        }
        else if (this.currentLang === 'ar') {
            this.SecondLangSrc = "assets/img/flag/us-flag.jpg";
            this.SecondLangName = "Eng";
            this.SecondLangCode = "en";

            this.CurrentLangSrc = "assets/img/flag/arab-flag.jpg";
            this.CurrentLangName = "عربي";
            this.CurrentLangCode = "ar";
        }
        //var curID = this.localS.getItem('CurrencyID');
        //if (curID == null) {

        //    this.currentCurrency = "2";
        //    this.setCurrency(false);
        //    this.toggleClassCurr();
        //}
        //else {
        //    this.currentCurrency = curID;
        //    if (this.currentCurrency == '1') {

        //        this.CurrentCurrencyName = "OMR";
        //        this.CurrentCurrencyCode = "1";

        //        this.SecondCurrencyName = "$";
        //        this.SecondCurrencyCode = "2";

        //    }
        //    else {

        //        this.CurrentCurrencyName = "$";
        //        this.CurrentCurrencyCode = "2";

        //        this.SecondCurrencyName = "OMR";
        //        this.SecondCurrencyCode = "1";
        //    }
        //}
    }

    public categoryData: CategoryModule[] | undefined;

    fillCategory() {
        // this.loader.open();
        this.serv.getService(this.ComID, 'Category')
            .subscribe((res: CategoryModule[]) => {
                this.categoryData = res;

               
            },
                (err: any) => {
                    //this.loader.close();
                    console.log(err);
                });
    }



    classApplied = false;
    //classAppliedCurr = false;

    toggleClassLang() {
        this.classApplied = !this.classApplied;
    }
    

    setLang() {
        if (this.currentLang === "ar") {
            this.currentLang = "en";
        }
        else {
            this.currentLang = "ar";

        }



        this.localS.setItem('Lang', this.currentLang);
        this.toggleClassLang();

        window.location.reload();
    }


}
